import _ from 'lodash'

const ProperCase =  function() {
  return function (input) {
    if(_.isArray(input)) {
      return _(input).map(_.startCase).join(', ')
    } else {
      return _.startCase(input)
    }
  }
}

export default ProperCase
